import { CONSTANTS } from '../../_data/lookups.js';
// Used by ForStep routing to enforce the deliberate invariant that for-loop whenTools are LessThan.
export function isNaturalLessThanToolStep(toolStep, toolMap) {
    const tool = toolMap.get(toolStep.toolHandle);
    if (!tool) {
        throw new Error(`Tool '${toolStep.toolHandle}' not found in toolMap`);
    }
    const isNaturalLessThan = toolStep.toolHandle === CONSTANTS.Handles.Tools.TOOL_NaturalLessThan;
    return { tool, isNaturalLessThan };
}
export { getSingleNonErrorBooleanOutputRoleName, readMaterializedBooleanDecision, } from '../macroStepDecisions.js';
export function getImmediatePreviousStep(threadSteps, currentStepCounter) {
    return currentStepCounter > 0 ? threadSteps[currentStepCounter - 1] : undefined;
}
export function getBranchPatternWindow(threadSteps, currentStepCounter) {
    // Branch routing inspects up to three prior steps to match expanded patterns like:
    // [BRANCH, WHEN(tool), WHAT(tool), <current boundary or remainder branch>]
    const prev = getImmediatePreviousStep(threadSteps, currentStepCounter);
    const prevPrev = currentStepCounter > 1 ? threadSteps[currentStepCounter - 2] : undefined;
    const prevPrevPrev = currentStepCounter > 2 ? threadSteps[currentStepCounter - 3] : undefined;
    return {
        prev,
        prevPrev,
        prevPrevPrev,
    };
}
